<button class="btn edit_i_btn">
    <i class="material-icons pointer" title="{{ 'CONSTANTS.EDIT' | translate }}">edit</i>
</button>